module.exports = __webpack_public_path__ + "img/upper_arm.b5b3b2c1.png";